export namespace UniversalLink {
  export const PRIVACY_LINK = 'https://www.prudential.com.vn/vi/mien-tru-trach-nhiem-va-quyen-so-huu/'
  export const TERM_LINK = 'https://www.prudential.com.vn/vi/chinh-sach-bao-mat/'
}
